import React from "react"
import { Tooltip } from "antd"
import "./UserBadge.scss"

// utils
import { getUserInitials } from "./userBadgeUtils"

interface UserBadgeProps {
  user: string
  size?: "sm" | "md"
  className?: string
  showFullName?: boolean
}

const UserBadge: React.FC<UserBadgeProps> = ({ user, size = "sm", className, showFullName }) => {
  const initials = getUserInitials(user)

  if (!initials) return null

  const classNames = [`user-badge-container no-text-highlight ${size}-size${className ? ` ${className}` : ""}`]

  return (
    <>
      {showFullName ? (
        <span className={`user-fullname ${size}-size`}>{user}</span>
      ) : (
        <Tooltip
          title={user}
          placement="bottom"
        >
          <div className={classNames.join(" ")}>{initials}</div>
        </Tooltip>
      )}
    </>
  )
}

export default UserBadge
